export default "__VITE_ASSET__CzQ8VQee__"